import React, { useState, useCallback, useEffect, useRef } from "react";
import cn from "classnames";
import styles from "./FleetList.module.scss";
import FleetTable from "components/myfleet_component/FleetTable";
import Gauge from "../echarts/Gauge";
import LineGraph from "../echarts/LineGraph";
import Donut from "../echarts/Donut";
import CustomDropDown from "components/CustomDropDown";
import PopUp from "../mychargers_component/PopUp";
import { getRequest, getMockyRequest } from "../../services/axiosBaseClient";
import {
  dateFormate,
  dateFormateToMeridiem,
  dateFormateFleet,
} from "../timeDiffCalc";
import { useSelector, useDispatch } from "react-redux";
import {
  getVehicleList,
  vehicledropdownTodoAsync,
} from "../../redux/vehicleSlice";
import ChargerDropDown from "components/ChargerDropdown";
import { useLocation } from "react-router-dom";
import moment from "moment";
import "moment-timezone";

const colorsArray = [
  { name: "charging", color: "#6A9930" },
  { name: "connected", color: "#73CEE5" },
  { name: "discharging", color: "#0077C0" },
  { name: "plugged", color: "#73CEE5" },
  { name: "available", color: "#BFC9D5" },
  { name: "unplugged", color: "#BFC9D5" },
  { name: "alert", color: "#A23B3E" },
  { name: "offline", color: "#565656" },
  { name: "down", color: "#A23B3E" },
  { name: "up", color: "#CDDC38" },
];

let balance = [];
let time = [];

export default function FleetList(props) {
  let vehicleListData = useSelector(getVehicleList);
  const setVehiCleListData = vehicleListData;
  var [siteMultiSelect, setSiteMultiSelecct] = useState([]);
  var [vehicleDrop, setVehicleDrop] = useState([]);
  var [chargerMultiSelect, setChargerMultiSelecct] = useState(vehicleListData);
  const [selectedList, selectedItem] = useState();
  const [outerSideClick, setOuterSideClick] = useState(true);
  const [outerSideClick1, setOuterSideClick1] = useState(true);
  const [selectAlert, setSelectAlert] = useState(false);
  const [checkCharging, setCheckCharging] = useState(null);
  const [checkDischarging, setCheckDischaring] = useState(null);
  const [powerPopup, setPowerPopup] = useState(false);
  const [donutGraphData, setDonutGraphData] = useState([]);
  const [fleetFinalData, setFleetFinalData] = useState([]);
  const [fleetFinalData2, setFleetFinalData2] = useState([]);
  const [vehicleSelected, setVehicleSelected] = useState();
  const [isApiCallingFleet, setApiCallingFleet] = useState(false);
  const firstRender = useRef(true);

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  // // console.log('------->',splitLocation)
  if (splitLocation[1] !== "myChargers") {
    localStorage.removeItem("shortingBy");
    localStorage.removeItem("checkedId");
  }

  function getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  let arr1 = getUniqueListBy(vehicleDrop, "value");

  // const checkVehDuplicate={};
  let vehicleData = getUniqueListBy(vehicleListData, "value");
  const dispatch = useDispatch();
  let fleetData = [];
  var statusCount = [];
  const evsesArray = [];
  const [realTimeData, setRealTimeData] = useState(fleetData);

  const filterData = useCallback((data) => {
    selectedItem(data);
  }, []);

  const vehicleFilterData = useCallback((data) => {
    // console.log(data)
    setVehicleSelected(data);
  }, []);

  let arrList = [{ label: "Select All", value: "0", vehID: "0", siteID: "0" }];

  if (selectedList !== undefined) {
    if (selectedList?.length > 0) {
      for (let i = 0; i < selectedList?.length; i++) {
        arrList.push({
          label: selectedList[i].label,
          name: selectedList[i].name,
          value: selectedList[i].value,
          vehID: selectedList[i].vehID,
          evseId: selectedList[i].evseId,
          siteID: selectedList[i]?.siteID,
        });
      }
    }

    arr1 = arr1?.filter((obj) =>
      arrList?.some(({ value }) => obj?.siteID === value)
    );
  }
  if (selectedList?.length === 0) {
    // let siteList = JSON.parse(localStorage.getItem('filterSite'));
    if (selectedList?.length > 0) {
      for (let i = 0; i < selectedList?.length; i++) {
        arrList.push({
          label: selectedList[i].label,
          name: selectedList[i]?.name,
          value: selectedList[i]?.value,
          vehID: selectedList[i]?.vehID,
          evseId: selectedList[i]?.evseId,
          siteID: selectedList[i]?.siteID,
        });
      }
      arr1 = arr1?.filter((obj) =>
        arrList?.some(({ value }) => obj?.siteID === value)
      );
    } else {
      arr1 = vehicleData;
    }
  }

  const selectedRecord = (data) => {
    if (data?.length > 0) {
      donnutGraphData(data);
    }
  };
  const selectFleetCharging = useCallback((data) => {
    setCheckCharging(data);
  });

  const selectFleetDischarging = useCallback((data) => {
    setCheckDischaring(data);
  });

  const [energyBalanceData, setEnergyBalanceData] = useState({
    time: time,
    balance: balance,
  });

  window.addEventListener("click", function (e) {
    if (
      e &&
      e.target &&
      document.getElementById("fleetClickbox")?.contains(e.target)
    ) {
      setOuterSideClick(true);
    } else {
      setOuterSideClick(false);
    }

    if (
      e &&
      e.target &&
      document.getElementById("fleetClickbox1")?.contains(e.target)
    ) {
      setOuterSideClick1(true);
    } else {
      setOuterSideClick1(false);
    }
  });

  const powerBalancePopup = () => {
    setPowerPopup(!powerPopup);
  };

  // const calSessionNetEnergy = (currentSoc, startSoc, batteryCapacity) => {
  // return Math.ceil((currentSoc - startSoc) * batteryCapacity / 60)
  // }

  const calReadyBy = (
    targetSoc,
    currentSoc,
    realTimePower,
    batteryCapacity,
    fleettimeZone,
    nextTrip
  ) => {
    // debugger
    if (targetSoc === undefined && currentSoc === undefined) {
      return "";
    } else {
      if (currentSoc >= targetSoc) {
        if (currentSoc > 0) {
          if (nextTrip !== "") {
            return "Ready";
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else if (realTimePower >= 0) {
        return "";
      } else {
        if (
          targetSoc !== undefined &&
          currentSoc !== undefined &&
          realTimePower !== undefined &&
          batteryCapacity !== undefined
        ) {
          // return dateFormate(new Date() + Math.ceil((targetSoc - currentSoc) / 100 * batteryCapacity / (realTimePower * -1000) * 60));
          return dateFormateFleet(
            new Date() +
              Math.ceil(
                ((((targetSoc - currentSoc) / 100) * batteryCapacity) /
                  (realTimePower * -1000)) *
                  60
              ),
            fleettimeZone
          );
        } else {
          return "";
        }
      }
    }
  };

  // function addHours(numOfHours, date = new Date()) {
  // date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  // return date;
  // }
  function addMinutes(minutes, date = new Date()) {
    return date.setTime(date.getTime() - minutes * 60000);
  }
  let evcsIds = "";
  let fleetDataVehicaleDetails;
  const getVehicaleDetails = async () => {
    var vehiId = vehicleListData
      .slice(1)
      .map((e) => {
        return e.value;
      })
      .join(",");
    // fleetDataVehicaleDetails = await getMockyRequest('https://run.mocky.io/v3/aceb0849-793b-4a48-8a49-8791aec3d472').then((res) => {
    fleetDataVehicaleDetails = await getRequest(
      "vehicles/details?vehicleIds=" + vehiId
    ).then((res) => {
      if (
        res?.data &&
        res?.data?.fullDetails &&
        res?.data?.fullDetails?.length >= 1
      ) {
        var evscId = res?.data?.fullDetails?.map((e) => {
          if (e.vehiclesDetails?.id !== undefined) {
            return e.vehiclesDetails?.id;
          }
        });
        for (let i = 0; i < evscId.length; i++) {
          if (evscId[i] !== undefined) {
            evcsIds += evscId[i] + ",";
          }
        }
      }

      return res;
      // return evs
    });

    let siteArray = [{ label: "Select All", value: "0" }];

    fleetDataVehicaleDetails?.data?.fullDetails.map((val) => {
      if (val?.siteDetails?.name !== undefined) {
        // for (let prop of siteArray) {
        //   if (prop?.value === val?.siteDetails?.siteId) {
        //     var includes = true;
        //   } else {
        //     includes = false;
        //   }
        // }
        // if (includes === false) {
        siteArray.push({
          label:
            val?.siteDetails?.address?.street +
            " " +
            val?.siteDetails?.address?.region +
            " " +
            val?.siteDetails?.address?.countryCode,
          value: val?.siteDetails?.siteId,
          vehID: val?.vehiclesDetails?.id,
          evseId: val?.evseDetails?.id,
          name: "site",
        });
        // }
      }
      const arr2 = getUniqueListBy(siteArray, "value");
      setSiteMultiSelecct(arr2);
    });

    let vehArray = [{ label: "Select All", value: "0", siteID: "0" }];
    fleetDataVehicaleDetails?.data?.fullDetails.map((val) => {
      if (val?.vehiclesDetails?.name !== undefined) {
        // for (let prop of siteArray) {
        //   if (prop?.value === val?.siteDetails?.siteId) {
        //     var includes = true;
        //   } else {
        //     includes = false;
        //   }
        // }
        // if (includes === false) {
        vehArray.push({
          label: val?.vehiclesDetails?.name,
          name: "vehicle",
          vehID: val?.vehiclesDetails?.id,
          value: val?.vehiclesDetails?.id,
          evseId: val?.evseDetails?.id,
          siteID: val?.siteDetails?.siteId,
        });
        // }
      }
      var checkVehDuplicate = getUniqueListBy(vehArray, "vehID");
      setVehicleDrop(checkVehDuplicate);
      // setSiteMultiSelecct(arr2)
    });

    if (!isApiCallingFleet) {
      if (window?.location?.href?.includes("myFleet")) {
        setApiCallingFleet(true);
        getdEvsesRealTime();
      }
    }
  };

  const checkVin = (val) => {
    if (val.match(":")) {
      return val.slice(-8);
    } else {
      return val.slice(-6);
    }
  };

  const checkCall = () => {
    setTimeout(() => {
      if (!isApiCallingFleet) {
        setApiCallingFleet(false);
        if (window?.location?.href?.includes("myFleet")) {
          getdEvsesRealTime();
        }
      }
    }, 5000);
  };

  const realtimeApi = async () => {
    const fromDate = new Date();
    const startStr = fromDate.toISOString();
    const toDate = addMinutes(30);
    const estr = new Date(toDate);
    const endStr = estr.toISOString();
    const evscId = evcsIds.replace(/,\s*$/, "");
    await getRequest(
      `vehicles/real-time?from=` +
        endStr +
        `&to=` +
        startStr +
        `&vehicleIds=` +
        evscId
    ).then((resData) => {
      if (resData?.status === 200) {
        // setInterval(() => {
        //       if(window?.location?.href?.includes('myFleet')){
        //         getdEvsesRealTime();

        //       }
        //     }, 5000);
        getdEvsesRealTime();
      }
    });
  };

  // let realdata
  const getdEvsesRealTime = async () => {
    fleetData = [];
    // const fromDate = dateFormateOnly(new Date());
    // const toDate = dateFormateOnly(addHours(12));
    // const searchString = qs.stringify({ from: fromDate, to: toDate, evses: evsesArray });
    const fromDate = new Date();
    const startStr = fromDate.toISOString();
    const toDate = addMinutes(30);
    const estr = new Date(toDate);
    const endStr = estr.toISOString();
    const evscId = evcsIds.replace(/,\s*$/, "");
    // let fleetRealTime = await getMockyRequest('https://run.mocky.io/v3/94d099df-accc-426c-9c45-fdd27ba9052c').then((resData) => {
    let fleetRealTime = await getRequest(
      `vehicles/real-time?from=` +
        endStr +
        `&to=` +
        startStr +
        `&vehicleIds=` +
        evscId
    ).then((resData) => {
      // debugger
      if (resData?.status === 200) {
        if (!isApiCallingFleet) {
          setApiCallingFleet(false);
          if (window?.location?.href?.includes("myFleet")) {
            checkCall();
          }
        }
        return resData;
      }
    });
    // if (fleetDataVehicaleDetails?.data && fleetDataVehicaleDetails?.data?.fullDetails && fleetDataVehicaleDetails?.data?.fullDetails?.length >= 1) {
    if (
      fleetDataVehicaleDetails &&
      fleetDataVehicaleDetails?.data?.fullDetails &&
      fleetDataVehicaleDetails?.data?.fullDetails?.length >= 1
    ) {
      fleetDataVehicaleDetails?.data?.fullDetails.map((item) => {
        //  debugger
        // var res = fleetRealTime?.data;
        var res = fleetRealTime;
        let colorCode;
        if (res) {
          let objIndex = res?.data?.data?.findIndex(
            (obj) => obj?.vehicleId === item?.vehiclesDetails?.id
          );
          const getcolor = colorsArray.find((obj) => {
            if (
              obj?.name ===
              res?.data?.data[objIndex]?.status?.toLocaleLowerCase()
            ) {
              return obj?.color;
            }
          });
          colorCode = getcolor?.color === undefined ? "" : getcolor?.color;
          // debugger
          let objreaSoc = res?.data?.data?.find((val) => {
            if (val?.vehicleId === item?.vehiclesDetails?.id) {
              return res?.data;
            }
          });
          let realTimeSoc = objreaSoc?.soc !== undefined ? objreaSoc?.soc : "";
          let objRealtime =
            objreaSoc?.realTimePower === undefined
              ? ""
              : objreaSoc?.realTimePower;

          let timeZone = vehicleData?.find((val) => {
            if (val.value === item?.vehiclesDetails?.id) {
              return vehicleData;
            }
          });

          let fleettimeZone =
            timeZone?.timeZone !== undefined ? timeZone?.timeZone : "";
          var fleetdate =
            item?.socRequirement?.startsAt !== undefined
              ? item?.socRequirement?.startsAt
              : "";
          let dateTime = dateFormateFleet(fleetdate, fleettimeZone);
          //  let dateTime=dateFormate(fleetdate)

          fleetData.push({
            transactionId:
              item?.transactionDetails?.id !== undefined
                ? item?.transactionDetails?.id
                : "",
            // statusName: item?.evseDetails?.status !== undefined ? item?.evseDetails?.status.toLocaleLowerCase() : '',
            statusName:
              res?.data?.data[objIndex]?.status !== undefined
                ? res?.data?.data[objIndex]?.status?.toLocaleLowerCase()
                : "unplugged",
            color: colorCode !== "" ? colorCode : "#B472B5",
            charger: {
              name: item?.evseDetails?.name,
              port: item?.evseDetails?.model.displayName,
            },
            // charger: { name: item?.evseDetails?.name, port: item?.evseDetails?.modelId },
            // status: { error1: item?.evseDetails?.status !== undefined ? item?.evseDetails?.status.toLocaleLowerCase() : '', type: item?.evseDetails?.status !== undefined ? item?.evseDetails?.status : '' },
            status: {
              error1:
                res?.data?.data[objIndex]?.status !== undefined
                  ? res?.data?.data[objIndex]?.status?.toLocaleLowerCase()
                  : "unplugged",
              type:
                res?.data?.data[objIndex]?.status !== undefined
                  ? res?.data?.data[objIndex]?.status?.toLocaleLowerCase()
                  : "unplugged",
            },
            vehicle: {
              name: item?.vehiclesDetails?.name,
              model: item?.vehiclesDetails?.modelDisplayName,
              vehID: item?.vehiclesDetails?.id,
            },
            soc: {
              current: realTimeSoc,
              target: item?.socRequirement?.soc,
              color: colorCode,
            },
            // site: item?.siteDetails?.name !== undefined ? item?.siteDetails?.name : '',
            site: {
              street: item?.siteDetails?.address?.street,
              region: item?.siteDetails?.address?.region,
              countryCode: item?.siteDetails?.address?.countryCode,
              siteId: item?.siteDetails?.siteId,
            },
            readyBy: calReadyBy(
              item?.socRequirement?.soc === undefined
                ? ""
                : item?.socRequirement?.soc,
              realTimeSoc,
              objRealtime,
              item?.vehiclesDetails?.model?.batteryCapacity,
              fleettimeZone,
              item?.socRequirement?.startsAt !== undefined
                ? item?.socRequirement?.startsAt
                : ""
            ),
            nextTrip: { date: dateTime, error: false },

            // nextTrip: { date: dateFormate(item?.socRequirement?.startsAt), error: false },
            // setChargingTime: { name: res?.vehicleStatusData[objIndex]?.vehicleStatusDto === undefined ? '' : res?.vehicleStatusData[objIndex]?.vehicleStatusDto === 'UP' ? 'Manual Charge' : res?.vehicleStatusData[objIndex]?.vehicleStatusDto === 'PLUGGED' ? 'Manual Charge' : res?.vehicleStatusData[objIndex]?.vehicleStatusDto === 'CHARGING' && (item?.socRequirement?.soc !== undefined && item?.socRequirement?.soc !== '') ? 'Back To Scheduled' : res?.vehicleStatusData[objIndex]?.vehicleStatusDto === 'CHARGING' && (item?.socRequirement?.soc === undefined || item?.socRequirement?.soc === '') ? 'Stop Charge' : 'Back To Scheduled', color: colorCode },
            // setChargingTime: { name: res?.data?.data[objIndex]?.status === undefined ? '' : res?.data?.data[objIndex]?.status === 'UP' ? 'Manual Charge':res?.data?.data[objIndex]?.status === undefined ? '' : res?.data?.data[objIndex]?.status === 'UNPLUGGED' ? '' : res?.data?.data[objIndex]?.status === 'PLUGGED' ? 'Manual Charge' : res?.data?.data[objIndex]?.status === 'CHARGING' && (item?.socRequirement?.startsAt !== undefined && item?.socRequirement?.startsAt !== '') ? 'Back To Scheduled' : 'Stop Charge', color: colorCode },
            setChargingTime: {
              name:
                res?.data?.data[objIndex]?.transactionMode === "SMART_CHARGING"
                  ? "Manual Charge"
                  : res?.data?.data[objIndex]?.transactionMode ===
                      "INSTANT_CHARGING" &&
                    item?.socRequirement?.startsAt !== undefined &&
                    item?.socRequirement?.startsAt !== ""
                  ? "Back To Scheduled"
                  : res?.data?.data[objIndex]?.transactionMode ===
                    "INSTANT_CHARGING"
                  ? "Stop Charge"
                  : "",
              color:
                res?.data?.data[objIndex]?.transactionMode === "SMART_CHARGING"
                  ? "#A23B3E"
                  : res?.data?.data[objIndex]?.transactionMode ===
                      "INSTANT_CHARGING" &&
                    item?.socRequirement?.startsAt !== undefined &&
                    item?.socRequirement?.startsAt !== ""
                  ? "#0077C0"
                  : res?.data?.data[objIndex]?.transactionMode ===
                    "INSTANT_CHARGING"
                  ? "#73CEE5"
                  : "",
            },

            startSoc:
              item?.evseDetails?.currentTransaction?.startSoc !== undefined
                ? item?.evseDetails?.currentTransaction?.startSoc
                : "",
            batteryCapacity: item?.vehiclesDetails?.model?.batteryCapacity,
            id:
              item?.vehiclesDetails?.id !== undefined
                ? item?.vehiclesDetails?.id
                : "",
            errorCount: 0,
            chargingPower: 0,
            disChargingPower: 0,
            VIN: checkVin(item?.vehiclesDetails?.vin),
            timezone: fleettimeZone,
          });

          // if (res.vehicleData) {
          // fleetData.map((val, index) => {
          // let objIndex = res?.vehicleData?.vehicleStatusData?.findIndex((obj => obj?.vehicleId === val?.id));
          // // let objIndex = res?.vehicleStatusData?.findIndex((obj => obj?.vehicleId === val?.id));
          // if (new Date(val?.nextTrip?.date).getTime() < new Date(val?.readyBy).getTime()) {
          // fleetData[0].errorCount = fleetData[0]?.errorCount + 1;
          // val.nextTrip.error = true;
          // }
          // if (res?.evseRealTimeData[objIndex]?.realTimePower !== undefined) {
          // if (parseInt(res?.evseRealTimeData[objIndex]?.realTimePower) > 0) {
          // fleetData[0].disChargingPower = (fleetData[0]?.disChargingPower) + (res?.vehicleData?.evseRealTimeData[objIndex]?.realTimePower/1000);

          // } else {
          // fleetData[0].chargingPower = (fleetData[0]?.chargingPower) + (res?.vehicleData?.evseRealTimeData[objIndex]?.realTimePower/1000);
          // }
          // }
          // })
          // }
        } else {
          fleetData.push({
            transactionId:
              item?.evseDetails?.currentTransaction?.id !== undefined
                ? item?.evseDetails?.currentTransaction?.id
                : "",
            // statusName: item?.evseDetails?.status !== undefined ? item?.evseDetails?.status.toLocaleLowerCase() : '',
            statusName:
              item?.vehicleStatus !== undefined
                ? item?.vehicleStatus?.toLocaleLowerCase()
                : "unplugged",
            color: colorCode !== "" ? colorCode : "#B472B5",
            charger: {
              name: item?.evseDetails?.name,
              port: item?.evseDetails?.modelId,
            },
            status: {
              error1:
                item?.vehicleStatus !== undefined
                  ? item?.vehicleStatus?.toLocaleLowerCase()
                  : "unplugged",
              type:
                item?.vehicleStatus !== undefined ? item?.vehicleStatus : "",
            },
            vehicle: {
              name: item?.vehiclesDetails?.name,
              model: item?.vehiclesDetails?.modelDisplayName,
              vehID: item?.vehiclesDetails?.id,
            },
            soc: {
              current: "",
              target: item?.socRequirement?.soc,
              color: colorCode,
            },
            // site: item?.siteDetails?.name !== undefined ? item?.siteDetails?.name : '',
            site: {
              street: item?.siteDetails?.address?.street,
              region: item?.siteDetails?.address?.region,
              countryCode: item?.siteDetails?.address?.countryCode,
              siteId: item?.siteDetails?.siteId,
            },
            readyBy: "",
            nextTrip: {
              date: dateFormate(item?.socRequirement?.startsAt),
              error: false,
            },
            setChargingTime: {
              name:
                item?.vehicleStatus === ""
                  ? ""
                  : item?.vehicleStatus === "UP"
                  ? "Manual Charge"
                  : item?.vehicleStatus === "PLUGGED"
                  ? "Manual Charge"
                  : "Back To Scheduled",
              color: colorCode,
            },
            startSoc:
              item?.evseDetails?.currentTransaction?.startSoc !== undefined
                ? item?.evseDetails?.currentTransaction?.startSoc
                : "",
            batteryCapacity: item?.vehiclesDetails?.model?.batteryCapacity,
            id:
              item?.evseDetails?.id !== undefined ? item?.evseDetails?.id : "",
            errorCount: 0,
            chargingPower: 0,
            disChargingPower: 0,
            VIN: checkVin(item?.vehiclesDetails?.vin),
          });
        }

        // function getUniqueListBy(arr, key) {
        //   return [...new Map(arr.map(item => [item[key], item])).values()]
        // }

        // let siteArray = [{ label: "Select All", value: '0' }];
        // fleetDataVehicaleDetails?.data?.fullDetails.map((val) => {
        //   if (val?.siteDetails?.name !== undefined) {
        //     // for (let prop of siteArray) {
        //     //   if (prop?.value === val?.siteDetails?.siteId) {
        //     //     var includes = true;
        //     //   } else {
        //     //     includes = false;
        //     //   }
        //     // }
        //     // if (includes === false) {
        //       siteArray.push({ label: val?.siteDetails?.address?.street + ' ' + val?.siteDetails?.address?.region + ' ' + val?.siteDetails?.address?.countryCode, value: val?.siteDetails?.siteId, vehID: val?.vehiclesDetails?.id, evseId: val?.evseDetails?.id, name: 'site' })
        //     // }
        //   }

        //   const arr2 = getUniqueListBy(siteArray, 'value')

        //   setSiteMultiSelecct(arr2)

        // })
      });
      var res = fleetRealTime;
      if (res?.data) {
        fleetData.map((val, index) => {
          let objIndex = res?.data?.data?.findIndex(
            (obj) => obj?.vehicleId === val?.id
          );
          // let objIndex = res?.vehicleStatusData?.findIndex((obj => obj?.vehicleId === val?.id));
          let objrealTime = res?.data?.data?.find((item) => {
            if (val?.id === item.vehicleId) {
              return res;
            }
          });

          let realTimePower =
            objrealTime?.realTimePower === undefined
              ? 0
              : objrealTime?.realTimePower;

          if (
            new Date(val?.nextTrip?.date).getTime() <
            new Date(val?.readyBy).getTime()
          ) {
            fleetData[0].errorCount = fleetData[0]?.errorCount + 1;
            val.nextTrip.error = true;
          }
          // if (res?.vehicleData[objIndex]?.evseRealTimeData?.realTimePower !== undefined) {

          if (realTimePower > 0) {
            fleetData[0].disChargingPower =
              fleetData[0]?.disChargingPower + realTimePower / 1000;
          } else {
            fleetData[0].chargingPower =
              fleetData[0]?.chargingPower + realTimePower / 1000;
          }
          // }
        });
      }

      donnutGraphData(fleetData);
      setFleetFinalData(fleetData);
      setRealTimeData(fleetData);
      // setDonutGraphData(statusCount);
      const EBalanceTime = [];
      const EBalance = [];

      if (fleetRealTime?.data?.energyBalances) {
        fleetRealTime?.data?.energyBalances.map((val, index) => {
          EBalance.push((val?.totalActivePower / 1000) * -1);
          EBalanceTime.push(dateFormateToMeridiem(val?.time));
        });
        setEnergyBalanceData({ balance: EBalance, time: EBalanceTime });
      }
    }
  };
  const donnutGraphData = (data) => {
    let donutData = data?.map((val) => {
      return { value: 1, name: val.statusName, color: val.color };
    });

    var statusData = [];
    var errorCounts = 0;
    var chargingCounts = 0;
    var dischargingCounts = 0;
    var pluggedCounts = 0;
    var unPluggedCounts = 0;
    var chargedCounts = 0;
    var downCounts = 0;
    var upCounts = 0;
    statusCount = [];
    donutData?.map((val) => {
      val?.name === "alert" ? errorCounts++ : (errorCounts += 0);
      val?.name === "charging" ? chargingCounts++ : (chargingCounts += 0);
      val?.name === "discharging"
        ? dischargingCounts++
        : (dischargingCounts += 0);
      val?.name === "plugged" ? pluggedCounts++ : (pluggedCounts += 0);
      val?.name === "available" ? chargedCounts++ : (chargedCounts += 0);
      val?.name === "unplugged" ? unPluggedCounts++ : (unPluggedCounts += 0);
      val?.name === "down" ? downCounts++ : (downCounts += 0);
      val?.name === "up" ? upCounts++ : (upCounts += 0);
    });

    for (let i = 0; i < donutData?.length; i++) {
      if (!statusData.includes(donutData[i].name)) {
        statusData.push(donutData[i].name);
        statusCount.push({
          value:
            donutData[i]?.name === "charging"
              ? chargingCounts
              : donutData[i]?.name === "alert"
              ? errorCounts
              : donutData[i].name === "discharging"
              ? dischargingCounts
              : donutData[i]?.name === "plugged"
              ? pluggedCounts
              : donutData[i]?.name === "available"
              ? chargedCounts
              : donutData[i]?.name === "down"
              ? downCounts
              : donutData[i]?.name === "up"
              ? upCounts
              : donutData[i]?.name === "unplugged"
              ? unPluggedCounts
              : "",
          name:
            donutData[i]?.name === "charging"
              ? donutData[i]?.name + " " + chargingCounts
              : donutData[i]?.name === "alert"
              ? donutData[i]?.name + " " + errorCounts
              : donutData[i].name === "discharging"
              ? donutData[i]?.name + " " + dischargingCounts
              : donutData[i]?.name === "plugged"
              ? donutData[i]?.name + " " + pluggedCounts
              : donutData[i]?.name === "available"
              ? donutData[i]?.name + " " + chargedCounts
              : donutData[i]?.name === "down"
              ? "disconnected" + " " + downCounts
              : donutData[i]?.name === "up"
              ? "connected" + " " + upCounts
              : donutData[i]?.name === "unplugged"
              ? donutData[i]?.name + " " + unPluggedCounts
              : "",
          color: donutData[i].color,
          count:
            donutData[i]?.name === "charging"
              ? chargingCounts
              : donutData[i]?.name === "alert"
              ? errorCounts
              : donutData[i].name === "discharging"
              ? dischargingCounts
              : donutData[i]?.name === "plugged"
              ? pluggedCounts
              : donutData[i]?.name === "available"
              ? chargedCounts
              : donutData[i]?.name === "down"
              ? downCounts
              : donutData[i]?.name === "up"
              ? upCounts
              : "",
        });
      }
    }
    if (donutData?.length > 0) {
      setTimeout(() => {
        donutt();
      }, 800);
    }
  };
  const donutt = () => {
    setDonutGraphData(statusCount);
  };
  useEffect(async () => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      await getVehicaleDetails();
    }
  }, [setVehiCleListData]);

  useEffect(() => {
    dispatch(vehicledropdownTodoAsync(chargerMultiSelect));
    // localStorage.removeItem('checkedId');
    // localStorage.removeItem('selectedId');
    return () => {
      setVehicleDrop([]);
      setOuterSideClick(true);
      setOuterSideClick1(true);
    };
  }, []);

  // window.addEventListener('resize', function() {
  //   // if (window.innerWidth >= 1200) {
  //     window.location.reload();
  //   // }
  // }, true);

  // useEffect(()=>{
  //   if(windowWidth>1300){
  //     debugger
  //     location.reload()
  //   }

  // },[windowWidth])

  return (
    <div className={cn("ChargerList", styles.block, styles.block_layout)}>
      <div className={cn(styles.flex, styles.flex_layout)}>
        <div className={cn(styles.flex3, styles.flex3_layout)}>
          <div className={cn(styles.flex3_item)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Site:"}
              </h3>
              {/* <div className={cn(styles.block3_spacer)} /> */}
              <div id="fleetClickbox" className={cn(styles.block3_item)}>
                <CustomDropDown
                  fleetClickCheck={outerSideClick}
                  dropdownData={siteMultiSelect}
                  chargerCallback={filterData}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex3_spacer)} />
          <div className={cn(styles.flex3_item)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Vehicle:"}
              </h3>
              {/* <div className={cn(styles.block3_spacer)} /> */}
              <div id="fleetClickbox1" className={cn(styles.block3_item)}>
                {/* <CustomDropDown fleetClickCheck={outerSideClick1} dropdownData={arr1} chargerCallback={filterData} /> */}
                {/* second dropdown called for vehicle here */}
                <ChargerDropDown
                  fleetClickCheck={outerSideClick1}
                  dropdownData={arr1}
                  chargerCallback={vehicleFilterData}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex3_spacer1)} />
          {/* <div className={cn(styles.flex3_item1)}>
            <div className={cn(styles.block2, styles.block2_layout)}>
              <div
                className={cn(styles.cover_block1, styles.cover_block1_layout)}
                onClick={() => props.navState(false)}
              >
                <h3 className={cn(styles.subtitle1, styles.subtitle1_layout)}>
                  {"Layout"}
                </h3>
              </div>

              <div
                className={cn(styles.cover_block, styles.cover_block_layout)}
                onClick={() => props.navState(false)}
              >
                <h3 className={cn(styles.subtitle1, styles.subtitle1_layout)}>
                  {"List"}
                </h3>
              </div>
            </div>
          </div> */}
        </div>

        <div className={cn(styles.flex4, styles.flex4_layout)}>
          <div className={cn(styles.flex4_item)}>
            <div className={cn(styles.box2, styles.box2_layout)}>
              <h5
                className={cn(
                  styles.charger_status_txt,
                  styles.charger_status_txt_layout
                )}
              >
                {"Vehicle Status"}
              </h5>
              <Donut
                data={donutGraphData}
                className={cn(
                  styles.energy_status_box,
                  styles.energy_status_box_layout
                )}
              />
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item1)}>
            <div className={cn(styles.box5, styles.box5_layout)}>
              <h5
                className={cn(styles.alerts_1_txt, styles.alerts_1_txt_layout)}
              >
                {"Alerts"}
              </h5>
              <div
                className={cn(styles.alert_cursor_pointer)}
                onClick={(e) => setSelectAlert(!selectAlert)}
              >
                <img
                  src={require("assets/ic_report.svg").default}
                  alt="Rectangle 5"
                  //disabling click for 13june
                  // onClick={(e) => setSelectAlert(!selectAlert)}
                  className={cn(styles.alerts_img, styles.alerts_img_layout)}
                />
                <h3
                  className={cn(
                    styles.alerts_2_txt,
                    styles.alerts_2_txt_layout,
                    styles.alert_top_15
                  )}
                >
                  {realTimeData[0]?.errorCount}
                </h3>
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item2)}>
            <div
              //disabling click for 13june
              // onClick={() => powerBalancePopup()}
              style={{ cursor: "pointer" }}
              className={cn(styles.box3, styles.box3_layout)}
            >
              <h5
                className={cn(
                  styles.energy_status_txt,
                  styles.energy_status_txt_layout
                )}
              >
                {"Real-Time Net Power Flow"}
              </h5>
              <LineGraph
                data={energyBalanceData}
                className={cn(
                  styles.energy_status_box,
                  styles.energy_status_box_layout
                )}
              />
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item3)}>
            <div className={cn(styles.box4, styles.box4_layout)}>
              <h5
                className={cn(
                  styles.curr_charging_1_txt,
                  styles.curr_charging_1_txt_layout
                )}
              >
                {"Charging"}
              </h5>
              <Gauge
                name="fleetCharging"
                chargingFleet={selectFleetCharging}
                color={"#6A9930"}
                dataVal={realTimeData[0]?.chargingPower * -1}
                className={cn(
                  styles.curr_charging_box,
                  styles.curr_charging_box_layout
                )}
              />
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item4)}>
            <div className={cn(styles.box4, styles.box4_layout)}>
              <h5
                className={cn(
                  styles.curr_charging_1_txt,
                  styles.curr_charging_1_txt_layout
                )}
              >
                {"Discharging"}
              </h5>
              <Gauge
                name="fleetDischarging"
                dischargingFleet={selectFleetDischarging}
                color={"#0077C0"}
                dataVal={realTimeData[0]?.disChargingPower}
                className={cn(styles.coo3_box, styles.coo3_box_layout)}
              />
            </div>
          </div>
        </div>

        <div className={cn(styles.box, styles.box_layout)}>
          <FleetTable
            dischargingState={checkDischarging}
            chargingState={checkCharging}
            alertState={selectAlert}
            filterVehicleData={vehicleSelected}
            filterdatas={selectedList}
            fleetsData={fleetFinalData}
            styles={{ width: "100%", overflowY: "scroll" }}
            selectedRecordCb={selectedRecord}
            className={cn(styles.flex10, styles.flex10_layout)}
          ></FleetTable>
        </div>
        <div>
          {powerPopup === true ? (
            <PopUp openState={powerBalancePopup} data={energyBalanceData} />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
